import vClickOutside from "click-outside-vue3";
var result_page = 1;
let params = new URLSearchParams(document.location.search.substring(1));
if (params.get("page")) {
  result_page = params.get("page");
}
const lists = {
  data() {
    return {
      lists: [],
      result_lists: [],
      years: [],
      last_year: null,
      next_year: null,
      current_year: null,
      all_lists: [],
      is_ja: $("html").attr("lang") === "ja",
      is_loading: true,
      is_pagination: true,
      is_result: false,
      page: result_page,
      result_headline: "",
      result_num: "",
      result_start_page_num: 0,
      result_end_page_num: 0,
      sid: "",
      total_page: 0,
      current_url: window.location.href.split(/[?#]/)[0],
      isShowExcerpt: true,
    };
  },
  computed: {
    temp: function () {
      const pathname = location.pathname.split("/");
      return pathname[pathname.length - 2];
    },
  },
  created() {
    this.getLists();
  },
  mounted() {
    window.addEventListener("wovnApiReady", this.getLang);
  },
  methods: {
    getLang() {
      if (window.WOVN && WOVN.io.getWovnUrl() !== undefined) {
        this.is_ja = WOVN.io.getCurrentLang().code === "ja";
      } else {
        this.is_ja = $("html").attr("lang") === "ja";
      }
      this.getLists();
    },
    changeYear: function (year) {
      scrollTo(0, 0);
      this.setLists(this.all_lists, year);
      this.getLastYear(year);
      this.getNextYear(year);
    },
    getLists: async function () {
      const data = await axios
        .get(location.pathname + "/data/list.json")
        .then((response) => response.data);

      if (this.is_ja) {
        this.all_lists = data.filter((list) => list.lang === "jp");
      } else {
        // EN版「三菱地所のニュースリリース」でのみ使用される
        const group_data = await axios
          .get("/group_news/data/list.json")
          .then((response) => response.data);
        const event_campaign_data = await axios
          .get("/event_campaign/data/list.json")
          .then((response) => response.data);
        const all_data = data.concat(group_data, event_campaign_data);
        this.all_lists = all_data.filter((list) => list.lang === "en");
      }

      this.getYears(this.all_lists);
      this.getLastYear(this.years[0]);
      this.getNextYear(this.years[0]);
      this.setLists(this.all_lists, this.years[0]);
      this.is_loading = false;
    },
    getYears: function (data) {
      const years = [
        ...new Set(
          data.map(function (a) {
            return parseInt(a.published.slice(0, 4));
          })
        ),
      ].sort((a, b) => b - a);
      this.years = years;
    },
    getLastYear: function (year) {
      const current_year_index = this.years.indexOf(year);
      this.last_year = this.years[current_year_index + 1];
      this.current_year = this.years[current_year_index];
    },
    getNextYear: function (year) {
      const current_year_index = this.years.indexOf(year);
      this.next_year = this.years[current_year_index - 1];
    },
    setLists: function (data, year) {
      const news = data
        .sort((a, b) => parseInt(b.published) - parseInt(a.published))
        .filter((c) => parseInt(c.published.slice(0, 4)) === year);

      let news_list = [];
      let last_month = 0;
      let isMonth = false;
      let count = -1;
      $.each(news, function (index, value) {
        const date = value.published;
        const year = date.substr(0, 4);
        const month = date.substr(4, 2);
        const day = date.substr(6, 2);

        isMonth = last_month == parseInt(month) ? false : true;
        last_month = parseInt(month);

        if (isMonth) {
          news_list.push({
            [parseInt(month)]: [
              {
                area: value.area,
                category: value.category,
                date: year + "/" + month + "/" + day,
                img_path: value.sumnail,
                is_pdf: value.pdf_icon,
                link: value.link,
                tag: value.tag,
                target: value.target,
                title: value.title,
              },
            ],
          });

          count++;
        } else {
          news_list[count][parseInt(month)].push({
            area: value.area,
            category: value.category,
            date: year + "/" + month + "/" + day,
            img_path: value.sumnail,
            is_pdf: value.pdf_icon,
            link: value.link,
            tag: value.tag,
            target: value.target,
            title: value.title,
          });
        }
      });

      this.lists = news_list;
    },
  },
};
const vueApp = Vue.createApp(lists).mount("#news-list");

// ----------------
// 条件から絞り込む
// ----------------

// ScrollLock
const bodyScrollLock = require("body-scroll-lock");

let isOpen = true;
function toggleScrollLock(target) {
  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;

  const targetElement = document.querySelector(target);

  if (isOpen) {
    disableBodyScroll(targetElement);
  } else {
    enableBodyScroll(targetElement);
  }

  isOpen = !isOpen;
}

// PC版　条件から絞り込む
const pc_filter = {
  data() {
    return {
      all_tags: [],
      areas: {
        domestic: [
          "北海道",
          "東北",
          "関東",
          "東京",
          "丸の内エリア（大手町・丸の内・有楽町）",
          "横浜",
          "中部",
          "関西",
          "中四国",
          "九州・沖縄",
        ],
        overseas: ["米国", "欧州", "アジア・オセアニア", "その他"],
      },
      categories: [
        "オフィスビル",
        "商業/アウトレットモール",
        "物流",
        "ホテル",
        "空港",
        "住宅",
        "海外",
        "投資マネジメント",
        "設計・監理",
        "不動産サービス",
        "新事業",
        "ＤＸ",
        "適時開示",
        "その他",
      ],
      years: [],
      inputArea: "",
      inputCategory: "",
      inputKeyword: "",
      inputTag: "",
      inputYear: "",
      isDisableSearch: false,
      isOpenArea: false,
      isOpenCategory: false,
      isOpenTag: false,
      isOpenYear: false,
      searchCount: 0,
      selectTag: "未選択",
      tags: [],
      tagPromise: null,
      isShowExcerpt: true,
    };
  },
  created() {
    this.tagPromise = this.getTags();
    this.getYears();
  },
  async mounted() {
    await this.tagPromise;
    this.searchCount = 1;
  },
  watch: {
    searchCount() {
      if (window.innerWidth > 768) {
        const url = new URL(location);
        const params = url.searchParams;

        if (this.searchCount == 1 && params.has("temp")) {
          this.isDisableSearch = true;
          vueApp.is_loading = true;

          if (params.has("news_year")) {
            this.inputYear = params.get("news_year");
          }
          if (params.has("news_category")) {
            const value = params.get("news_category");
            this.inputCategory = value;

            const checkbox = $("input[name='pc-categories']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("news_area")) {
            const value = params.get("news_area");
            this.inputArea = value;

            const checkbox = $("input[name='pc-areas']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("news_tag")) {
            const value = params.get("news_tag");
            this.inputTag = value;

            const checkbox = $("input[name='pc-tags']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("kw")) {
            this.inputKeyword = params.get("kw");
          }

          this.getSearchResult();
        }

        if (this.searchCount > 1) {
          vueApp.page = "";
          result_page = 1;
          this.isDisableSearch = true;
          vueApp.is_loading = true;

          const pathname = url.pathname.split("/");
          url.searchParams.set("temp", pathname[pathname.length - 2]);
          url.searchParams.set("page", vueApp.page == 0 ? "" : vueApp.page);
          url.searchParams.set("sid", vueApp.sid == 0 ? "" : vueApp.sid);
          url.searchParams.set("news_year", this.inputYear);
          url.searchParams.set("news_category", this.inputCategory);
          url.searchParams.set("news_area", this.inputArea);
          url.searchParams.set("news_tag", this.inputTag);
          url.searchParams.set("kw", this.inputKeyword);
          history.replaceState("", "", url.toString());

          this.getSearchResult();
        }
      }
    },
  },
  methods: {
    // ----------
    // 年
    // ----------
    getYears: async function () {
      const data = await axios
        .get(location.pathname + "/data/list.json")
        .then((response) => response.data);

      const all_lists = data.filter((list) => list.lang === "jp");
      const years = [
        ...new Set(
          all_lists.map(function (a) {
            return parseInt(a.published.slice(0, 4));
          })
        ),
      ].sort((a, b) => b - a);

      this.years = ["選択なし"].concat(years);
    },
    openYear() {
      this.isOpenYear = !this.isOpenYear;
    },
    closeYear() {
      if (this.isOpenYear) this.isOpenYear = false;
    },
    selectYear(value) {
      this.isOpenYear = false;

      value == "選択なし" ? (this.inputYear = "") : (this.inputYear = value);
    },
    // ----------
    // 事業分野
    // ----------
    openCategory() {
      this.isOpenCategory = true;
      toggleScrollLock(".category-label-container");
    },
    closeCategory() {
      this.isOpenCategory = false;

      const checkVal = $("input[name='pc-categories']:checked")
        .map(function () {
          return $(this).val();
        })
        .get()
        .join(",");
      this.inputCategory = checkVal;
      toggleScrollLock(".category-label-container");
    },
    // ----------
    // エリア
    // ----------
    openArea() {
      this.isOpenArea = true;
      toggleScrollLock(".area-content");
    },
    closeArea() {
      this.isOpenArea = false;

      const checkVal = $("input[name='pc-areas']:checked")
        .map(function () {
          return $(this).val();
        })
        .get()
        .join(",");
      this.inputArea = checkVal;

      toggleScrollLock(".area-content");
    },
    // ----------
    // ハッシュタグ
    // ----------
    getTags: async function () {
      const data = await axios
        .get("/assets/data/news_tag.json")
        .then((response) => response.data);

      const pathname = location.pathname.split("/");
      const groupJson = data.filter(
        (list) => list.group === pathname[pathname.length - 2]
      )[0].tag;
      groupJson ? (this.tags = groupJson) : (this.tags = []);

      const allJson = data.filter((list) => list.group === "ALL")[0].tag;
      this.all_tags = allJson.filter((tag) => !this.tags?.includes(tag));
    },
    openTag() {
      this.isOpenTag = true;
      toggleScrollLock(".tag-main-content");
    },
    closeTag() {
      this.isOpenTag = false;
      toggleScrollLock(".tag-main-content");
    },
    checkTag(value) {
      const checkbox = $("input[name='pc-tags']:checked");
      if (checkbox.length == 0) {
        this.selectTag = "未選択";
        this.inputTag = "";
      } else if (checkbox.length < 5) {
        const checkVal = $("input[name='pc-tags']:checked")
          .map(function () {
            return $(this).val();
          })
          .get()
          .join(",");
        this.selectTag = checkVal;
        this.inputTag = this.selectTag;
      } else {
        for (let i = 0; i < checkbox.length; i++) {
          if (checkbox[i]._value == value) {
            checkbox[i].checked = false;
          }
        }
      }
    },
    // ----------
    // 選択条件をクリア
    // ----------
    clear() {
      this.inputYear = "";
      this.inputCategory = "";
      this.inputArea = "";
      this.inputTag = "";
      this.inputKeyword = "";

      const checkCategory = $("input[name='pc-categories']");
      for (let i = 0; i < checkCategory.length; i++) {
        checkCategory[i].checked = false;
      }

      const checkArea = $("input[name='pc-areas']");
      for (let i = 0; i < checkArea.length; i++) {
        checkArea[i].checked = false;
      }

      const checkTag = $("input[name='pc-tags']");
      for (let i = 0; i < checkTag.length; i++) {
        checkTag[i].checked = false;
      }
    },
    // ----------
    // 検索する
    // ----------
    searchValue() {
      this.searchCount++;
    },
    getSearchResult: async function () {
      const pathname = location.pathname.split("/");
      const data = await axios
        .get("https://search-mec2.dga.jp", {
          params: {
            temp: pathname[pathname.length - 2],
            cpn: 100,
            page: vueApp.page == 0 ? "" : vueApp.page,
            ie: "u",
            sid: vueApp.page == 0 ? "" : vueApp.sid,
            ord: "d",
            news_lang: "jp",
            news_year: this.inputYear,
            news_category: this.inputCategory,
            news_area: this.inputArea,
            news_tag: this.inputTag,
            kw: this.inputKeyword,
          },
        })
        .then((response) => response.data)
        .catch((error) => console.log("error", error));

      const search_results = data.search_results.sort(
        (a, b) => parseInt(b.news_published) - parseInt(a.news_published)
      );

      let news_list = [];
      $.each(search_results, function (index, value) {
        const date = value.news_published;
        const year = date.substr(0, 4);
        const month = date.substr(4, 2);
        const day = date.substr(6, 2);

        news_list.push({
          area: value.news_area,
          body: value.body,
          category: value.news_category,
          date: year + "/" + month + "/" + day,
          img_path: value.image_url,
          is_pdf: value.news_pdf_icon,
          link: value.uri,
          tag: value.news_tag,
          target: value.news_target,
          title: value.title,
        });
      });

      let result_headline = [];
      if (this.inputYear) {
        result_headline.push(this.inputYear + "年");
      }
      if (this.inputCategory) {
        result_headline.push(this.inputCategory);
      }
      if (this.inputArea) {
        result_headline.push(this.inputArea);
      }
      if (this.inputTag) {
        result_headline.push(this.inputTag);
      }
      if (this.inputKeyword) {
        result_headline.push(this.inputKeyword);
        vueApp.isShowExcerpt = true;
      } else {
        vueApp.isShowExcerpt = false;
      }
      vueApp.result_headline = result_headline.join("、");

      const search_info = data.search_info;
      vueApp.sid = vueApp.sid == "" ? search_info.sid : vueApp.sid;
      vueApp.result_num = search_info.search_result_num;
      vueApp.result_start_page_num = search_info.start_page_num;
      vueApp.result_end_page_num = search_info.end_page_num;

      vueApp.result_lists = news_list;
      vueApp.is_result = true;
      vueApp.is_pagination = vueApp.is_result && vueApp.result_num > 100;
      vueApp.total_page = Math.ceil(vueApp.result_num / 100);

      this.isDisableSearch = false;
      vueApp.is_loading = false;

      const load_list = setInterval(function () {
        if ($(".result_pagination").length) {
          clearInterval(load_list);
          $(".result_pagination").html("");
          if (result_page > 1 && vueApp.total_page > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_prev" href="' +
                location.href.replace(
                  /page=\d{1,}|page=/g,
                  "page=" + (Number(result_page) - 1)
                ) +
                '"></a>'
            );
          }
          if (Number(result_page) - 1 > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_number" href="' +
                location.href.replace(/page=\d{1,}|page=/g, "page=1") +
                '">1</a>'
            );
            if (Number(result_page) - 2 > 1) {
              $(".result_pagination").append(
                '<span class="result_pagination_dots"></span>'
              );
            }
          }
          var page_cnt = 0;
          for (let i = 0; i < vueApp.total_page; i++) {
            if (
              (result_page == 1 && i + 1 >= result_page) ||
              (result_page == vueApp.total_page &&
                i + 1 >= Number(result_page) - 2) ||
              (result_page != vueApp.total_page &&
                i + 1 >= Number(result_page) - 1)
            ) {
              page_cnt++;
              if (page_cnt > 3) {
                if (Number(result_page) + 2 < vueApp.total_page) {
                  $(".result_pagination").append(
                    '<span class="result_pagination_dots"></span>'
                  );
                }
                if (result_page != vueApp.total_page) {
                  $(".result_pagination").append(
                    '<a class="result_pagination_number" href="' +
                      location.href.replace(
                        /page=\d{1,}|page=/g,
                        "page=" + vueApp.total_page
                      ) +
                      '">' +
                      vueApp.total_page +
                      "</a>"
                  );
                }
                break;
              } else {
                if (result_page == i + 1) {
                  $(".result_pagination").append(
                    '<span class="result_pagination_number is-current">' +
                      (i + 1) +
                      "</span>"
                  );
                } else {
                  $(".result_pagination").append(
                    '<a class="result_pagination_number" href="' +
                      location.href.replace(
                        /page=\d{1,}|page=/g,
                        "page=" + (i + 1)
                      ) +
                      '">' +
                      (i + 1) +
                      "</a>"
                  );
                }
              }
            } else {
              continue;
            }
          }
          if (result_page < vueApp.total_page && vueApp.total_page > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_next" href="' +
                location.href.replace(
                  /page=\d{1,}|page=/g,
                  "page=" + (Number(result_page) + 1)
                ) +
                '"></a>'
            );
          }
        }
      });
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
if ($(".pc-search-menu").css("display") != "none") {
  Vue.createApp(pc_filter).mount(".pc-search-menu");
}

// SP版　アコーディオン
$(function () {
  $(".open").click(function () {
    $(this).toggleClass("active");
    $(this).next(".search-menu").slideToggle();
  });
});

var winPos;
// SP版　条件から絞り込む
const filter = {
  data() {
    return {
      all_tags: [],
      areas: {
        domestic: [
          "北海道",
          "東北",
          "関東",
          "東京",
          "丸の内エリア（大手町・丸の内・有楽町）",
          "横浜",
          "中部",
          "関西",
          "中四国",
          "九州・沖縄",
        ],
        overseas: ["米国", "欧州", "アジア・オセアニア", "その他"],
      },
      categories: [
        "オフィスビル",
        "商業/アウトレットモール",
        "物流",
        "ホテル",
        "空港",
        "住宅",
        "海外",
        "投資マネジメント",
        "設計・監理",
        "不動産サービス",
        "新事業",
        "ＤＸ",
        "適時開示",
        "その他",
      ],
      years: [],
      inputArea: "",
      inputCategory: "",
      inputKeyword: "",
      inputTag: "",
      inputYear: "",
      isDisableSearch: false,
      isOpenArea: false,
      isOpenCategory: false,
      isOpenTag: false,
      isOpenYear: false,
      isShowArea: false,
      isShowCategory: false,
      isShowTag: false,
      searchCount: 0,
      selectArea: "",
      selectCategory: "",
      selectTag: "未選択",
      tags: [],
      tagPromise: null,
      isShowExcerpt: true,
    };
  },
  created() {
    this.getYears();
    this.tagPromise = this.getTags();
  },
  async mounted() {
    await this.tagPromise;
    this.searchCount = 1;
  },
  watch: {
    searchCount() {
      if (window.innerWidth < 769) {
        const url = new URL(location);
        const params = url.searchParams;

        if (this.searchCount == 1 && params.has("temp")) {
          this.isDisableSearch = true;
          vueApp.is_loading = true;

          if (params.has("news_year")) {
            this.inputYear = params.get("news_year");
          }
          if (params.has("news_category")) {
            const value = params.get("news_category");
            this.inputCategory = value;

            const checkbox = $("input[name='categories']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("news_area")) {
            const value = params.get("news_area");
            this.inputArea = value;

            const checkbox = $("input[name='areas']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("news_tag")) {
            const value = params.get("news_tag");
            this.inputTag = value;
            this.selectTag = value;

            const checkbox = $("input[name='tags']");
            for (let i = 0; i < checkbox.length; i++) {
              if (value.split(",").includes(checkbox[i].defaultValue)) {
                checkbox[i].checked = true;
              }
            }
          }
          if (params.has("kw")) {
            this.inputKeyword = params.get("kw");
          }

          this.getSearchResult();
        }

        if (this.searchCount > 1) {
          vueApp.page = "";
          result_page = 1;
          this.isDisableSearch = true;
          vueApp.is_loading = true;

          const pathname = url.pathname.split("/");
          url.searchParams.set("temp", pathname[pathname.length - 2]);
          url.searchParams.set("page", vueApp.page == 0 ? "" : vueApp.page);
          url.searchParams.set("sid", vueApp.sid == 0 ? "" : vueApp.sid);
          url.searchParams.set("news_year", this.inputYear);
          url.searchParams.set("news_category", this.inputCategory);
          url.searchParams.set("news_area", this.inputArea);
          url.searchParams.set("news_tag", this.inputTag);
          url.searchParams.set("kw", this.inputKeyword);
          history.replaceState("", "", url.toString());

          this.getSearchResult();
        }
      }
    },
  },
  methods: {
    // ----------
    // 年
    // ----------
    getYears: async function () {
      const data = await axios
        .get(location.pathname + "/data/list.json")
        .then((response) => response.data);

      const all_lists = data.filter((list) => list.lang === "jp");
      const years = [
        ...new Set(
          all_lists.map(function (a) {
            return parseInt(a.published.slice(0, 4));
          })
        ),
      ].sort((a, b) => b - a);

      this.years = ["選択なし"].concat(years);
    },
    openYear() {
      this.isOpenYear = !this.isOpenYear;
    },
    closeYear() {
      if (this.isOpenYear) this.isOpenYear = false;
    },
    selectYear(value) {
      this.isOpenYear = false;

      value == "選択なし" ? (this.inputYear = "") : (this.inputYear = value);
    },
    // ----------
    // 事業分野
    // ----------
    openCategory() {
      this.isOpenCategory = true;
      this.isShowCategory = false;
      //toggleScrollLock(".category-label-container");
      winPos = $(window).scrollTop();
      $("body").css({ top: -winPos, position: "fixed" });
    },
    closeCategory() {
      this.isOpenCategory = false;

      // チェック削除
      const checkbox = $("input[name='categories']");
      for (let i = 0; i < checkbox.length; i++) {
        checkbox[i].checked = false;
      }

      // チェック追加
      if (this.inputCategory != "") {
        const selected_value = this.inputCategory.split(",");
        for (let i = 0; i < checkbox.length; i++) {
          if (selected_value.includes(checkbox[i]._value)) {
            checkbox[i].checked = true;
          }
        }
      }

      //toggleScrollLock(".category-label-container");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    checkCategory() {
      this.isShowCategory = true;

      const checkbox = $("input[name='categories']:checked");
      if (checkbox.length == 0 && this.inputCategory == "")
        this.isShowCategory = false;

      const checkVal = checkbox
        .map(function () {
          return $(this).val();
        })
        .get()
        .join(",");
      this.selectCategory = checkVal;
      if (this.inputCategory == this.selectCategory)
        this.isShowCategory = false;
    },
    selectedCategory() {
      this.isOpenCategory = false;
      this.inputCategory = this.selectCategory;

      //toggleScrollLock(".category-label-container");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    // ----------
    // エリア
    // ----------
    openArea() {
      this.isOpenArea = true;
      this.isShowArea = false;
      //toggleScrollLock(".area-content");
      winPos = $(window).scrollTop();
      $("body").css({ top: -winPos, position: "fixed" });
    },
    closeArea() {
      this.isOpenArea = false;

      // チェック削除
      const checkbox = $("input[name='areas']");
      for (let i = 0; i < checkbox.length; i++) {
        checkbox[i].checked = false;
      }

      // チェック追加
      if (this.inputArea != "") {
        const selected_value = this.inputArea.split(",");
        for (let i = 0; i < checkbox.length; i++) {
          if (selected_value.includes(checkbox[i]._value)) {
            checkbox[i].checked = true;
          }
        }
      }

      //toggleScrollLock(".area-content");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    checkArea() {
      this.isShowArea = true;

      const checkbox = $("input[name='areas']:checked");
      if (checkbox.length == 0 && this.inputArea == "") this.isShowArea = false;

      const checkVal = checkbox
        .map(function () {
          return $(this).val();
        })
        .get()
        .join(",");
      this.selectArea = checkVal;
      if (this.inputArea == this.selectArea) this.isShowArea = false;
    },
    selectedArea() {
      this.isOpenArea = false;
      this.inputArea = this.selectArea;

      //toggleScrollLock(".area-content");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    // ----------
    // ハッシュタグ
    // ----------
    getTags: async function () {
      const data = await axios
        .get("/assets/data/news_tag.json")
        .then((response) => response.data);

      const pathname = location.pathname.split("/");
      const groupJson = data.filter(
        (list) => list.group === pathname[pathname.length - 2]
      )[0].tag;
      groupJson ? (this.tags = groupJson) : (this.tags = []);

      const allJson = data.filter((list) => list.group === "ALL")[0].tag;
      this.all_tags = allJson.filter((tag) => !this.tags?.includes(tag));
    },
    openTag() {
      this.isOpenTag = true;
      this.isShowTag = false;
      //toggleScrollLock(".tag-content");
      winPos = $(window).scrollTop();
      $("body").css({ top: -winPos, position: "fixed" });
    },
    closeTag() {
      this.isOpenTag = false;

      // チェック削除
      const checkbox = $("input[name='tags']");
      for (let i = 0; i < checkbox.length; i++) {
        checkbox[i].checked = false;
      }

      // チェック追加
      if (this.inputTag != "") {
        const selected_value = this.inputTag.split(",");
        for (let i = 0; i < checkbox.length; i++) {
          if (selected_value.includes(checkbox[i]._value)) {
            checkbox[i].checked = true;
          }
        }
      }

      this.inputTag == ""
        ? (this.selectTag = "未選択")
        : (this.selectTag = this.inputTag);

      //toggleScrollLock(".tag-content");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    checkTag(value) {
      const checkbox = $("input[name='tags']:checked");

      if (checkbox.length == 0 && this.inputTag == "") {
        this.isShowTag = false;
        this.selectTag = "未選択";
      } else if (checkbox.length == 0) {
        this.selectTag = "未選択";
      } else if (checkbox.length < 5) {
        const checkVal = checkbox
          .map(function () {
            return $(this).val();
          })
          .get()
          .join(",");
        this.selectTag = checkVal;

        this.selectTag == this.inputTag
          ? (this.isShowTag = false)
          : (this.isShowTag = true);
      } else {
        for (let i = 0; i < checkbox.length; i++) {
          if (checkbox[i]._value == value) {
            checkbox[i].checked = false;
          }
        }

        this.selectTag == this.inputTag
          ? (this.isShowTag = false)
          : (this.isShowTag = true);
      }
    },
    selectedTag() {
      this.isOpenTag = false;
      this.selectTag == "未選択"
        ? (this.inputTag = "")
        : (this.inputTag = this.selectTag);

      //toggleScrollLock(".tag-content");
      $("body").css({ top: 0, position: "" });
      window.scrollTo(0, winPos);
    },
    // ----------
    // 選択条件をクリア
    // ----------
    clear() {
      this.inputYear = "";
      this.inputCategory = "";
      this.inputArea = "";
      this.inputTag = "";
      this.inputKeyword = "";
      this.selectArea = "";
      this.selectCategory = "";
      this.selectTag = "未選択";

      const checkCategory = $("input[name='categories']");
      for (let i = 0; i < checkCategory.length; i++) {
        checkCategory[i].checked = false;
      }

      const checkArea = $("input[name='areas']");
      for (let i = 0; i < checkArea.length; i++) {
        checkArea[i].checked = false;
      }

      const checkTag = $("input[name='tags']");
      for (let i = 0; i < checkTag.length; i++) {
        checkTag[i].checked = false;
      }
    },
    // ----------
    // 検索する
    // ----------
    searchValue() {
      this.searchCount++;
    },
    getSearchResult: async function () {
      const pathname = location.pathname.split("/");
      const data = await axios
        .get("https://search-mec2.dga.jp", {
          params: {
            temp: pathname[pathname.length - 2],
            cpn: 100,
            page: vueApp.page == 0 ? "" : vueApp.page,
            ie: "u",
            sid: vueApp.page == 0 ? "" : vueApp.sid,
            ord: "d",
            news_lang: "jp",
            news_year: this.inputYear,
            news_category: this.inputCategory,
            news_area: this.inputArea,
            news_tag: this.inputTag,
            kw: this.inputKeyword,
          },
        })
        .then((response) => response.data)
        .catch((error) => console.log("error", error));

      const search_results = data.search_results.sort(
        (a, b) => parseInt(b.news_published) - parseInt(a.news_published)
      );

      let news_list = [];
      $.each(search_results, function (index, value) {
        const date = value.news_published;
        const year = date.substr(0, 4);
        const month = date.substr(4, 2);
        const day = date.substr(6, 2);

        news_list.push({
          area: value.news_area,
          body: value.body,
          category: value.news_category,
          date: year + "/" + month + "/" + day,
          img_path: value.image_url,
          is_pdf: value.news_pdf_icon,
          link: value.uri,
          tag: value.news_tag,
          target: value.news_target,
          title: value.title,
        });
      });

      let result_headline = [];
      if (this.inputYear) {
        result_headline.push(this.inputYear + "年");
      }
      if (this.inputCategory) {
        result_headline.push(this.inputCategory);
      }
      if (this.inputArea) {
        result_headline.push(this.inputArea);
      }
      if (this.inputTag) {
        result_headline.push(this.inputTag);
      }
      if (this.inputKeyword) {
        result_headline.push(this.inputKeyword);
        vueApp.isShowExcerpt = true;
      } else {
        vueApp.isShowExcerpt = false;
      }
      vueApp.result_headline = result_headline.join("、");

      const search_info = data.search_info;
      vueApp.sid = vueApp.sid == "" ? search_info.sid : vueApp.sid;
      vueApp.result_num = search_info.search_result_num;
      vueApp.result_start_page_num = search_info.start_page_num;
      vueApp.result_end_page_num = search_info.end_page_num;

      vueApp.result_lists = news_list;
      vueApp.is_result = true;
      vueApp.is_pagination = vueApp.is_result && vueApp.result_num > 100;
      vueApp.total_page = Math.ceil(vueApp.result_num / 100);

      this.isDisableSearch = false;
      vueApp.is_loading = false;

      const load_list = setInterval(function () {
        if ($(".result_pagination").length) {
          clearInterval(load_list);
          $(".result_pagination").html("");
          if (result_page > 1 && vueApp.total_page > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_prev" href="' +
                location.href.replace(
                  /page=\d{1,}|page=/g,
                  "page=" + (Number(result_page) - 1)
                ) +
                '"></a>'
            );
          }
          if (Number(result_page) - 1 > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_number" href="' +
                location.href.replace(/page=\d{1,}|page=/g, "page=1") +
                '">1</a>'
            );
            if (Number(result_page) - 2 > 1) {
              $(".result_pagination").append(
                '<span class="result_pagination_dots"></span>'
              );
            }
          }
          var page_cnt = 0;
          for (let i = 0; i < vueApp.total_page; i++) {
            if (
              (result_page == 1 && i + 1 >= result_page) ||
              (result_page == vueApp.total_page &&
                i + 1 >= Number(result_page) - 2) ||
              (result_page != vueApp.total_page &&
                i + 1 >= Number(result_page) - 1)
            ) {
              page_cnt++;
              if (page_cnt > 3) {
                if (Number(result_page) + 2 < vueApp.total_page) {
                  $(".result_pagination").append(
                    '<span class="result_pagination_dots"></span>'
                  );
                }
                if (result_page != vueApp.total_page) {
                  $(".result_pagination").append(
                    '<a class="result_pagination_number" href="' +
                      location.href.replace(
                        /page=\d{1,}|page=/g,
                        "page=" + vueApp.total_page
                      ) +
                      '">' +
                      vueApp.total_page +
                      "</a>"
                  );
                }
                break;
              } else {
                if (result_page == i + 1) {
                  $(".result_pagination").append(
                    '<span class="result_pagination_number is-current">' +
                      (i + 1) +
                      "</span>"
                  );
                } else {
                  $(".result_pagination").append(
                    '<a class="result_pagination_number" href="' +
                      location.href.replace(
                        /page=\d{1,}|page=/g,
                        "page=" + (i + 1)
                      ) +
                      '">' +
                      (i + 1) +
                      "</a>"
                  );
                }
              }
            } else {
              continue;
            }
          }
          if (result_page < vueApp.total_page && vueApp.total_page > 1) {
            $(".result_pagination").append(
              '<a class="result_pagination_next" href="' +
                location.href.replace(
                  /page=\d{1,}|page=/g,
                  "page=" + (Number(result_page) + 1)
                ) +
                '"></a>'
            );
          }
        }
      });
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
Vue.createApp(filter).mount(".sp-search-menu");
